"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSynthesize;

var _react = require("react");

var _Context = _interopRequireDefault(require("./Context"));

var _createNativeUtterance = _interopRequireDefault(require("./createNativeUtterance"));

function useSynthesize() {
  var _useContext = (0, _react.useContext)(_Context["default"]),
      ponyfill = _useContext.ponyfill,
      synthesize = _useContext.synthesize;

  return function (utteranceOrText, progressFn) {
    if (typeof utteranceOrText === 'string') {
      utteranceOrText = (0, _createNativeUtterance["default"])(ponyfill, {
        text: utteranceOrText
      });
    }

    return synthesize(ponyfill, utteranceOrText, {
      onStart: progressFn && function () {
        return progressFn();
      }
    });
  };
}